import { VBadge } from "@/components/ui";
import type { AssetStatus } from "@/domains/assets/api/types";

const STATUS_CONFIG: Record<
  AssetStatus,
  { label: string; color: React.ComponentProps<typeof VBadge>["color"] }
> = {
  available: { label: "Beschikbaar", color: "success" },
  inUse: { label: "In gebruik", color: "info" },
  maintenance: { label: "Onderhoud", color: "warning" },
  outOfService: { label: "Buiten werking", color: "error" },
};

type AssetStatusBadgeProps = {
  status: AssetStatus;
};

export function AssetStatusBadge({ status }: AssetStatusBadgeProps): React.JSX.Element {
  const { label, color } = STATUS_CONFIG[status];
  return <VBadge color={color}>{label}</VBadge>;
}
